<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <p class=".title ma-2">Modify Host Payment Terms</p>
    <v-form ref="updHoctTerms" v-model="updHoctTermsValid">
     <v-row no-gutters>

      <v-col class="ma-2">
       <v-menu
              v-model="hoct_term1_datummenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              readonly 
              offset-y
              min-width="290px"
        >
        <template v-slot:activator="{ on }">
            <v-text-field
              v-model="hoct.hoct_term1_datum"
              label="Payment term 1 Date"
              v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker v-model="hoct.hoct_term1_datum2" :first-day-of-week="1" @input="hoct.hoct_term1_datum = $moment(hoct.hoct_term1_datum2).format('DD-MM-YYYY'); hoct_term1_datummenu = false"></v-date-picker>
       </v-menu>  

      </v-col>
      <v-col class="ma-2">
       <v-select v-model="hoct.hoct_term1_tijd" required :items="tijd_idKeuzes" item-value="tijd_id" item-text="tijd_oms" label="Payment term 1 Time"></v-select>
      </v-col>
      <v-col class="ma-2">
          <v-text-field v-model="hoct.hoct_term1_bedrag" required label="Amount" :prefix=hoct.valu_code_verk type="number" :rules="hctr_bedragRules"></v-text-field>
        </v-col>

     </v-row>

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="updHoctTerms" :disabled="!updHoctTermsValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      updHoctTermsValid: false,
      hoct_encrid: null,
      tijd_idKeuzes: [],
      hoct: {},
      hoct_term1_datummenu: false,
      hoct_term2_datummenu: false,
      hctr_bedragRules: [
          v => (v && parseFloat(v) != 0.0)  || "An amount is required"
      ]    
    }
  },
  methods: {
    open(hoct_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.hoct_encrid = hoct_encrid;
      this.tijd_id = '';
      this.$axios
        .post("ares/json/ares/huov/hctr/getHoctTerms.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHoctTerms"
          },
          getHoctTerms: {
            hoct_encrid: hoct_encrid,
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hoct = res.data.getHoctTerms;
            res.data.getHoctTerms.tijd_idKeuzes.forEach(function(tijd) {
            deze.tijd_idKeuzes.push(tijd); 
           });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updHoctTerms() { 
      this.$axios
        .post("ares/json/ares/huov/hctr/updHoctTerms.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updHoctTerms"
          },
          updHoctTerms: {
            hoct_encrid: this.hoct_encrid,
            hoct_term1_tijd: this.hoct.hoct_term1_tijd,
            hoct_term1_datum: this.hoct.hoct_term1_datum,
            hoct_term1_bedrag: parseFloat(this.hoct.hoct_term1_bedrag)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {    
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.updHoctTerms.text,
              color: res.data.updHoctTerms.color
            }); 
            if (res.data.updHoctTerms.color == "success") {
              setTimeout(() => { this.$router.reload('/huov/onHuov/' + res.data.updHoctTerms.huov_encrid);  }, 1000); 
            }
            this.dialog = false;
          }
        })
    },
  }
}
</script>

